import { render, staticRenderFns } from "./publishedKnowledgeSection.vue?vue&type=template&id=3e843936&scoped=true"
import script from "./publishedKnowledgeSection.vue?vue&type=script&lang=js"
export * from "./publishedKnowledgeSection.vue?vue&type=script&lang=js"
import style0 from "./publishedKnowledgeSection.vue?vue&type=style&index=0&id=3e843936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e843936",
  null
  
)

export default component.exports